/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import { Container, Card, FormControl, InputLabel, Checkbox, FormHelperText } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Box, Button } from '@material-ui/core';
import SearchNotFound from '../../../SearchNotFound';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableFooter from '@material-ui/core/TableFooter';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles';
import services from '../Service';
import { makeStyles } from '@material-ui/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';
import { format } from 'date-fns';

var screenCode = "GTNWISESUMMARYREPORT"

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));

export default function GTNWiseSummaryView() {
    const navigate = useNavigate();
    const componentRef = useRef();

    const [csvHeaders, SetCsvHeaders] = useState([]);
    const classes = useStyles();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [fromDatevalue, setFromDateValue] = useState(new Date());
    const [toDatevalue, setToDateValue] = useState(new Date());
    const [gtnWiseSummaryDetails, setGtnWiseSummaryDetails] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [totalValue, setTotalValue] = useState(0);
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'GTN Wise Summary Report'
    });
    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: '',
        date: null,
        isActive: true
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupName: '',
        factoryName: '',
        date: ''
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, gtnWiseSummaryDetails.length - page * rowsPerPage);

    const DailyPurchasingEfficiencySummaryReportSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.array().required('Please select at least one Fresh collection center').min(1, 'Please select at least one Fresh collection center'),
    });

    const truncateSheetName = (name) => {
        return name.length > 31 ? name.substring(0, 31) : name;
    }

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            date: formData.date,
            isActive: formData.isActive
        },
        validationSchema: DailyPurchasingEfficiencySummaryReportSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm(values));
        },
    });

    const handleSelectChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedOptions(selectedOptions.length === factory.length ? [] : factory.map((option) => option.value));
        } else {
            setSelectedOptions(value);
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
    };

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = factory.find((entity) => entity.value === selected[0]);
            return option ? option.label : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? option.label : null;
                } else {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? option.label : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    useEffect(() => {
        getPermissions()
    }, []);

    useEffect(() => {
        trackPromise(GetAllGroups());
    }, []);

    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
        setFromDateValue(new Date());
        setToDateValue(new Date());
    }, [formik.values.groupID]);

    useEffect(() => {
        setGtnWiseSummaryDetails([]);
        setFromDateValue(new Date());
        setToDateValue(new Date());
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setGtnWiseSummaryDetails([]);
    }, [fromDatevalue, toDatevalue]);

    useEffect(() => {
        setToDateValue(new Date());
    }, [fromDatevalue]);

    useEffect(() => {
        setGtnWiseSummaryDetails([]);
        setFromDateValue(new Date());
        setToDateValue(new Date());
    }, [selectedOptions]);

    useEffect(() => {
        setValues({
            ...values,
            operationEntityID: selectedOptions
        })
    }, [selectedOptions]);

    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [factory]);

    useEffect(() => {
        const total = gtnWiseSummaryDetails.reduce((acc, item) => acc + (((item.value / item.quantity).toFixed(2)) * item.quantity || 0), 0);
        setTotalValue(total);
    }, [gtnWiseSummaryDetails]);

    async function SubmitForm(values) {
        let model = {
            groupID: parseInt(values.groupID),
            operationEntityID: selectedOptions.map(x => x).join(',').toString(),
            fromDate: fromDatevalue == null ? null : moment(fromDatevalue).format('YYYY-MM-DD'),
            toDate: toDatevalue == null ? null : moment(toDatevalue).format('YYYY-MM-DD'),
        }
        var res = await services.GetGTNWiseSummaryReportDetails(model)
        setGtnWiseSummaryDetails(res);
        getSelectedDropdownValuesForReport(model);
        setPage(0);
    }

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWGTNWISESUMMARYREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group)

        })
        trackPromise(GetAllGroups());

    }

    async function clearAll() {
        setFromDateValue(new Date());
        setToDateValue(new Date());
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetVCCFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setFactory(newOptionArray);
        }
    }

    async function createFile() {
        const formattedFromDate = format(fromDatevalue, 'yyyy-MM-dd');
        const formattedToDate = format(toDatevalue, 'yyyy-MM-dd');

        var file = await createDataForExcel(gtnWiseSummaryDetails);
        var settings = {
            sheetName: 'GTN Wise Summary Report',
            fileName: `GTN Wise Summary Report - ${formattedFromDate} - ${formattedToDate}`,
            writeOptions: {}
        };
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: truncateSheetName('GTN Wise Summary Report'),
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    async function createDataForExcel(data) {
        var res = [];
        if (data != null) {
            const groupedData = [];
            data.forEach((item) => {
                const lastGroup = groupedData[groupedData.length - 1];
                if (
                    lastGroup &&
                    lastGroup.gtnNumber === item.gtnNumber &&
                    lastGroup.lorryNumber === item.lorryNumber
                ) {
                    lastGroup.rows.push(item);
                } else {
                    groupedData.push({
                        gtnNumber: item.gtnNumber,
                        gtnNo: item.gtnNo,
                        lorryNumber: item.lorryNumber,
                        rows: [item],
                    });
                }
            });

            groupedData.forEach((group) => {
                group.rows.forEach((item, index) => {
                    const vr = {
                        'Order Date': moment(item.orderDate).format('YYYY-MM-DD'),
                        'FCC': item.factoryName,
                        // 'Order Number': item.ordernumber,
                        'GTN Number': index === 0 ? group.gtnNumber : '',
                        'GTN Sequence No': index === 0 ? group.gtnNo : '',
                        'Lorry Number': index === 0 ? group.lorryNumber : '',
                        'Sku Code': item.skuCode,
                        'Description': item.skuDescription,
                        // 'GRN Price': item.grnPrice === 0 || item.grnPrice === null
                        //     ? '-'
                        //     : parseFloat(item.grnPrice).toLocaleString('en-US', {
                        //         minimumFractionDigits: 2,
                        //         maximumFractionDigits: 2,
                        //     }),
                        'GRN WAC Price': item.value === 0 || item.value === null || item.quantity == 0 || item.quantity == null
                            ? '-'
                            : parseFloat(item.value / item.quantity).toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }),
                        'Quantity': item.quantity?.toFixed(2),
                        'Value (Rs)': item.value === 0 || item.value === null
                            ? '-'
                            : parseFloat(((item.value / item.quantity).toFixed(2)) * item.quantity).toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }),

                    };
                    res.push(vr);
                });
            });

            const vrTwo = {
                'Order Date': 'Total Value (Rs)',
                'Value (Rs)': totalValue === 0
                    ? '-'
                    : parseFloat(totalValue).toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }),
            };
            res.push(vrTwo);
            res.push({});
            res.push({});
        }
        return res;
    }

    function getSelectedDropdownValuesForReport(data) {
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = factory.find(y => x === y.value).label
            facName.push(fildered)
        });
        let groups = group.find(x => x.groupID == formik.values.groupID)
        setSelectedSearchValues((prevState) => ({
            ...prevState,
            groupName: groups.groupName,
            factoryName: facName.length == 0 ? 'All Fresh Collection Centers' : facName.join(', '),
            date: new Date(fromDatevalue).toLocaleDateString()
        }));
    }

    return (
        <>
            <LoadingComponent />
            <Page title="GTN Wise Summary Report |  FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group </MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center "
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                            renderValue={(selected) => renderSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedOptions.length === factory.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {factory.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}
                                    </FormControl>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            size="small"
                                            label="From Date *"
                                            openTo="day"
                                            type="date"
                                            value={fromDatevalue}
                                            onChange={(newValue) => {
                                                setFromDateValue(newValue);
                                            }}
                                            maxDate={new Date()}
                                            renderInput={(params) =>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                />}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            size="small"
                                            label="To Date *"
                                            openTo="day"
                                            type="date"
                                            value={toDatevalue}
                                            onChange={(newValue) => {
                                                setToDateValue(newValue);
                                            }}
                                            maxDate={new Date()}
                                            renderInput={(params) =>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                />}
                                        />
                                    </LocalizationProvider>
                                    <div>
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                        > Clear</Button>
                                    </div>
                                    <div>
                                        <Button
                                            type="submit"
                                            color='secondary'
                                            variant="outlined"
                                        >Search</Button>
                                    </div>
                                </Stack>
                                <br />
                                <>
                                    {gtnWiseSummaryDetails.length != 0 ? (
                                        <>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} >
                                                <Paper className={classes.paper}>
                                                    <TableContainer className={classes.tableContainer} sx={{ maxWidth: 1800 }}>
                                                        <Table size="small" aria-label="simple table" sx={{ width: 1150 }}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell sx={{ border: "1px solid black" }} align="left" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center', whiteSpace: 'nowrap' }}>Order Date</TableCell>
                                                                    <TableCell sx={{ border: "1px solid black" }} align="left" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>FCC</TableCell>
                                                                    {/* <TableCell sx={{ border: "1px solid black" }} style={{ verticalAlign: 'top', textAlign: 'center', justifyContent: 'center' }}>Order Number</TableCell> */}
                                                                    <TableCell sx={{ border: "1px solid black" }} style={{ verticalAlign: 'top', textAlign: 'center', justifyContent: 'center' }}>GTN Number</TableCell>
                                                                    <TableCell sx={{ border: "1px solid black" }} style={{ verticalAlign: 'top', textAlign: 'center', justifyContent: 'center' }}>GTN Sequence No</TableCell>
                                                                    <TableCell sx={{ border: "1px solid black" }} style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>Lorry Number</TableCell>
                                                                    <TableCell sx={{ border: "1px solid black" }} style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>Sku Code</TableCell>
                                                                    <TableCell sx={{ border: "1px solid black" }} style={{ verticalAlign: 'top', textAlign: 'left', justifyContent: 'center' }}>Description</TableCell>
                                                                    {/* <TableCell sx={{ border: "1px solid black" }} align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>GRN Price</TableCell> */}
                                                                    <TableCell sx={{ border: "1px solid black" }} align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>GRN WAC Price</TableCell>
                                                                    <TableCell sx={{ border: "1px solid black" }} align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Quantity</TableCell>
                                                                    <TableCell sx={{ border: "1px solid black" }} align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Value (Rs)</TableCell>


                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {(() => {
                                                                    const groupedData = [];
                                                                    gtnWiseSummaryDetails.forEach((item) => {
                                                                        const lastGroup = groupedData[groupedData.length - 1];
                                                                        if (
                                                                            lastGroup &&
                                                                            lastGroup.gtnNumber === item.gtnNumber &&
                                                                            lastGroup.lorryNumber === item.lorryNumber
                                                                        ) {
                                                                            lastGroup.rows.push(item);
                                                                        } else {
                                                                            groupedData.push({
                                                                                gtnNumber: item.gtnNumber,
                                                                                gtnNo: item.gtnNo,
                                                                                lorryNumber: item.lorryNumber,
                                                                                rows: [item],
                                                                            });
                                                                        }
                                                                    });
                                                                    return groupedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((group, groupIndex) => (
                                                                        <React.Fragment key={groupIndex}>
                                                                            {group.rows.map((row, rowIndex) => (
                                                                                <TableRow key={rowIndex}>
                                                                                    <TableCell
                                                                                        sx={{
                                                                                            border: "1px solid black",
                                                                                            whiteSpace: "nowrap",
                                                                                            verticalAlign: "middle"
                                                                                        }}
                                                                                        align="left"
                                                                                    >
                                                                                        {moment(row.orderDate).format("YYYY-MM-DD")}
                                                                                    </TableCell>
                                                                                    <TableCell sx={{ border: "1px solid black" }} align="left">{row.factoryName}</TableCell>
                                                                                    {/* <TableCell sx={{ border: "1px solid black" }} align="right">{row.ordernumber}</TableCell> */}
                                                                                    {rowIndex === 0 && (
                                                                                        <TableCell
                                                                                            sx={{ border: "1px solid black" }}
                                                                                            align="center"
                                                                                            rowSpan={group.rows.length}
                                                                                        >
                                                                                            {group.gtnNumber}
                                                                                        </TableCell>
                                                                                    )}
                                                                                    {rowIndex === 0 && (
                                                                                        <TableCell
                                                                                            sx={{ border: "1px solid black" }}
                                                                                            align="center"
                                                                                            rowSpan={group.rows.length}
                                                                                        >
                                                                                            {group.gtnNo == null ? '-' : group.gtnNo}
                                                                                        </TableCell>
                                                                                    )}
                                                                                    {rowIndex === 0 && (
                                                                                        <TableCell
                                                                                            sx={{ border: "1px solid black" }}
                                                                                            align="center"
                                                                                            rowSpan={group.rows.length}
                                                                                        >
                                                                                            {group.lorryNumber}
                                                                                        </TableCell>
                                                                                    )}
                                                                                    <TableCell sx={{ border: "1px solid black" }} align="right">{row.skuCode}</TableCell>
                                                                                    <TableCell sx={{ border: "1px solid black" }} align="left">{row.skuDescription}</TableCell>
                                                                                    {/* <TableCell sx={{ border: "1px solid black" }} align="right">
                                                                                        {row.grnPrice == 0 || null
                                                                                            ? "-"
                                                                                            : parseFloat(row.grnPrice).toLocaleString("en-US", {
                                                                                                minimumFractionDigits: 2,
                                                                                                maximumFractionDigits: 2,
                                                                                            })}
                                                                                    </TableCell> */}
                                                                                    <TableCell sx={{ border: "1px solid black" }} align="right">
                                                                                        {row.quantity == 0 || row.value == 0 || row.quantity == null || row.value == null
                                                                                            ? "-"
                                                                                            : parseFloat(row.value / row.quantity).toLocaleString("en-US", {
                                                                                                minimumFractionDigits: 2,
                                                                                                maximumFractionDigits: 2,
                                                                                            })}
                                                                                    </TableCell>
                                                                                    <TableCell sx={{ border: "1px solid black" }} align="right">{row.quantity?.toFixed(2)}</TableCell>
                                                                                    <TableCell sx={{ border: "1px solid black" }} align="right">
                                                                                        {row.value == 0 || row.value == null
                                                                                            ? "-"
                                                                                            : parseFloat(((row.value / row.quantity).toFixed(2)) * row.quantity).toLocaleString("en-US", {
                                                                                                minimumFractionDigits: 2,
                                                                                                maximumFractionDigits: 2,
                                                                                            })}
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            ))}
                                                                        </React.Fragment>
                                                                    ));
                                                                })()}
                                                                <TableRow>
                                                                    <TableCell
                                                                        sx={{ border: "1px solid black" }}
                                                                        style={{
                                                                            fontWeight: 'bold',
                                                                            verticalAlign: 'top',
                                                                            textAlign: 'left',
                                                                        }}
                                                                        colSpan={9}
                                                                    >
                                                                        Total Value (Rs)
                                                                    </TableCell>
                                                                    <TableCell sx={{ border: "1px solid black" }} style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {totalValue === 0 ? '-' : parseFloat(totalValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    {/* <TableCell sx={{ border: "1px solid black" }} >
                                                                    </TableCell> */}
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <TableFooter>
                                                        <TableRow>
                                                            <TableCell colSpan={8} style={{ padding: 0 }}>
                                                                <Box
                                                                    sx={{
                                                                        display: 'flex',
                                                                        justifyContent: 'flex-end',
                                                                        alignItems: 'center',
                                                                        paddingRight: 2
                                                                    }}
                                                                >
                                                                    <TablePagination
                                                                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                                        colSpan={6}
                                                                        count={gtnWiseSummaryDetails.length}
                                                                        rowsPerPage={rowsPerPage}
                                                                        page={page}
                                                                        SelectProps={{
                                                                            inputProps: {
                                                                                'aria-label': 'rows per page',
                                                                            },
                                                                            native: true,
                                                                        }}
                                                                        onPageChange={handleChangePage}
                                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                                        ActionsComponent={TablePaginationActions}
                                                                    />
                                                                </Box>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableFooter>
                                                </Paper>
                                            </Stack>
                                        </>
                                    )
                                        : <SearchNotFound searchQuery="GTN Wise Summary Report" />}</>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    {gtnWiseSummaryDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"GTN Wise Summary Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    gtnWiseSummaryDetails={gtnWiseSummaryDetails}
                                    searchData={selectedSearchValues}
                                    totalValue={totalValue}
                                />
                            </div>
                        </Box>
                        : null}
                </Container>
            </Page>
        </>
    );
}

